<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <ScheduleTable
          :userTripRequestCode="row.userTripRequestCode"
          :isExpand="true"
          :tripStartDate="row.tripStartDate"
          :tripEndDate="row.tripEndDate"
          :disabled="
            row.userTripRequestStatus === 'D' ||
              row.userTripRequestStatus === 'S' ||
              row.userTripRequestStatus === 'Y'
          "
        />
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.userTripRequestStatus === 'N'
              ? 'primary'
              : row.userTripRequestStatus === 'S'
              ? 'warning'
              : row.userTripRequestStatus === 'Y'
              ? 'success'
              : row.userTripRequestStatus === 'D' ||
                row.userTripRequestStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.v_userTripRequestStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              openEditPage({
                pageType: 'detail',
                params: { code: row.userTripRequestCode },
                query: { userTripRequestNo: row.userTripRequestNo },
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="allow('M')"
          v-show="
            row.userTripRequestStatus == 'N' || row.userTripRequestStatus == 'R'
          "
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              openEditPage({
                pageType: 'edit',
                params: { code: row.userTripRequestCode },
                query: { userTripRequestNo: row.userTripRequestNo },
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-show="
            row.userTripRequestStatus == 'N' || row.userTripRequestStatus == 'R'
          "
          v-if="allow('D')"
        >
          <i
            class="el-icon-delete tool-btn"
            @click="del(row.userTripRequestCode)"
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_submit_review') || '提交审核'"
          placement="top"
          v-if="allow('T')"
        >
          <i
            class="el-icon-s-check tool-btn"
            @click="submitReview(row.userTripRequestCode)"
            v-show="
              row.userTripRequestStatus === 'N' ||
                row.userTripRequestStatus === 'R'
            "
          ></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns.js'
import ScheduleTable from '../../schedule-table/table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { ScheduleTable },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    components: {},
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'personal-myTravelDetail',
        params: { ...params, pageType },
        query,
      })
    },
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .userTripRequestDelApi({ userTripRequestCode: code })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    submitReview(val) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核?',
        this.$l('INDEX.tips_question_title') || '提示',
        {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .userTripRequestOaApply({
            userTripRequestCode: val,
            linkUrl: this.$joinURL(`/opview/myTravel/${val}`, {
              joinOrigin: true,
              joinBasePath: false,
            }),
          })
          .then(() => {
            this.loadingClose()
            this.$message.success(
              this.$l('INDEX.tips_Submitted_successfully') || '提交成功!'
            )
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
  },
}
</script>
